export function downloadFileFromUrl(url, fileName = 'download') {
  if (!url) {
    return;
  }

  const link = document.createElement('a');
  link.href = url;
  link.download = fileName || 'download';
  link.rel = 'noreferrer';
  link.style.display = 'none';

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
